module.exports = __webpack_public_path__ + "img/portfolio-thumbnail_TFHotels.e6049952.jpg";